import React, {FC} from 'react';
import {Form, useFormikContext} from 'formik';
import {materialsCustomPart, MaybeNull,} from "../../helpers/productTypes";
import {CustomPartFormType} from "./CustomPart";
import s from "../Product/product.module.sass";
import {ProductInputCustom, TextInput} from "../../common/Form";
import CustomPartSubmit from "./CustomPartSubmit";
import CustomPartMaterialsArray from "./CustomPartMaterialsArray";


const CustomPartPVC: FC<{ filtered_materials_array: MaybeNull<materialsCustomPart[]> }> = ({filtered_materials_array}) => {
    const {values} = useFormikContext<CustomPartFormType>();
    const {price} = values;
    return (
        <Form>
            <div className={s.block}>
                <h3>PVC Length(ft)</h3>
                <div className={s.options}>
                    <ProductInputCustom name="width_string"/>
                </div>
            </div>
            <CustomPartMaterialsArray filtered_materials_array={filtered_materials_array}/>
            <div className={s.block}>
                <TextInput type={"text"} label={'Note'} name="note"/>
            </div>
            <div className={s.total}>
                <span>Total: </span>
                <span>{price}$</span>
            </div>
            <CustomPartSubmit/>
        </Form>
    );
};

export default CustomPartPVC;